import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrafficCone } from '@fortawesome/pro-regular-svg-icons';
import { PortalLinearProgress } from '../common/PortalLinearProgress';
import { useSelector } from 'react-redux';
import { useJobPolling } from './utils';
import { getUser, isUserAdmin, isUserSAMSuperUser } from '../Layout/utils';

export const JobProcessingBanner = () => {
  useJobPolling();

  const { isAutomatedJobCompleted, isCheckingAutomatedJobStatus, processingJobs } = useSelector(
    (state) => state.samReducer,
  );

  const user = useSelector((state) => state.AWSReducer.user);
  const impersonation = useSelector((state) => state.impersonationReducer.impersonation);

  const currentUser = getUser(user, impersonation);

  const isSamSuperUserUp = isUserAdmin(currentUser) || isUserSAMSuperUser(currentUser);

  const isJobRunning = !isAutomatedJobCompleted;

  return isCheckingAutomatedJobStatus ? (
    <Alert
      icon={<FontAwesomeIcon icon={faTrafficCone} />}
      className="myOdu__alert banner"
      sx={{ mb: 2 }}
    >
      Checking SAM status...
    </Alert>
  ) : isJobRunning ? (
    <Alert
      icon={<></>}
      className="myOdu__alert banner"
      sx={{
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%',
        },
      }}
    >
      <AlertTitle>View Only Mode</AlertTitle>

      {processingJobs.map((processingJob) => {
        const { name, totalCount, processedCount } = processingJob;
        return (
          <Box>
            Sam is currently processing {isSamSuperUserUp ? name : 'a'} job and in a view-only mode.
            Check back for updates.
            <PortalLinearProgress
              value={totalCount > 0 ? Math.floor((processedCount / totalCount) * 100) : 0}
            />
          </Box>
        );
      })}
    </Alert>
  ) : (
    <></>
  );
};
